var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm-9.15-23.625c22.175 0 34.3-18.375 34.3-34.3 0-.525 0-1.05-.025-1.55 2.35-1.7 4.4-3.825 6.025-6.25-2.15.95-4.475 1.6-6.925 1.9 2.5-1.5 4.4-3.85 5.3-6.675a24.412 24.412 0 0 1-7.65 2.925c-2.2-2.35-5.325-3.8-8.8-3.8-6.65 0-12.05 5.4-12.05 12.05 0 .95.1 1.875.325 2.75-10.025-.5-18.9-5.3-24.85-12.6a12.093 12.093 0 0 0-1.625 6.05c0 4.175 2.125 7.875 5.375 10.025-1.975-.05-3.825-.6-5.45-1.5v.15c0 5.85 4.15 10.7 9.675 11.825-1 .275-2.075.425-3.175.425a11.51 11.51 0 0 1-2.275-.225 12.037 12.037 0 0 0 11.25 8.375A24.233 24.233 0 0 1 25.3 71.1c-.975 0-1.925-.05-2.875-.175 5.275 3.45 11.625 5.45 18.425 5.45z","fill":"#E9E9E9","fillRule":"nonzero"}));
}

TwitterIcon.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
